module.exports = __webpack_public_path__ + "img/ios_en.8809deea.jpg";